<template lang="pug">
  div
    v-navigation-drawer.hidden-print-only(v-model='drawer', clipped, app)
      .pr-4.pt-4
        uf-patient-detail
      v-list(v-if="gestationInteraction.iuid")
        template(v-for='item in items')
          v-list-tile(v-if='!item.items', :key='item.title', :to="item.link")
            v-list-tile-content
              v-list-tile-title {{ $t(item.title) | capitalize }}
          v-list-group(v-else, :key='item.title', v-model='item.expend')
            v-list-tile(slot='activator')
              v-list-tile-content
                v-list-tile-title {{ $t(item.title) | capitalize }}
            v-list-tile(v-for='subItem in item.items', :key='subItem.title', :color='subItem.color', :to="subItem.link")
              v-list-tile-action
                v-icon(right, :color='subItem.color') {{ subItem.action }}
              v-list-tile-content(:title="subItem.title")
                template(v-if="!subItem.itemsAdd")
                  v-list-tile-title {{ subItem.i18n === false ? subItem.title : $t(subItem.title) | capitalize }}
                template(v-else)
                  v-list-tile-title
                    v-menu()
                      v-btn.ma-0(slot='activator', :color='subItem.color', small, flat)
                        v-icon(:color="subItem.color", small, left) {{ subItem.btnIcon }}
                        | {{ subItem.i18n === false ? subItem.title : $t(subItem.title) | capitalize }}
                      v-list
                        v-list-tile(
                          v-for='(itemMenu, index) in subItem.itemsAdd'
                          :key='index'
                          @click='addItem(item.title, itemMenu)'
                          )
                          v-list-tile-title {{ subItem.i18n === false ? itemMenu.title : $t(itemMenu.title) | capitalize }}
              v-list-tile-action(v-if="!subItem.itemsAdd && subItem.link.params.formId !== 'gestationalAge'")
                v-btn(icon @click.native.prevent='removeExamForm(subItem.link.params.formId, subItem.title)')
                  v-icon(color="error") delete
    v-toolbar.primary.hidden-print-only(app, dark, dense, clipped-left)
      v-toolbar-side-icon(@click.stop='drawer = !drawer')
      v-toolbar-items
        v-btn(flat, to='/')
          img(src='/static/icon.ico', height='38')
        v-btn(flat v-for="(item, i) in toolbarItems" :key="i" :to="item.link" v-if="item.link !== '/'") {{item.title}}
      v-spacer
      v-menu(offset-y)
        v-btn(slot='activator' flat) {{ companyName }}
          v-icon arrow_drop_down
        v-list(subheader dense)
          v-subheader {{ $t('words.companies') | capitalize }}
          v-list-tile(
            v-for="company in companiesSorted"
            :key="company.id"
            @click="changeCompany(company.identity)"
          )
            v-list-tile-title {{ company.name }}
          v-subheader {{user.displayName}}
          v-list-tile(to='/profile')
            v-list-tile-title {{ $t('words.profile') | capitalize }}
          v-list-tile(@click='signOut')
            v-list-tile-title {{ $t('words.logout') | capitalize }}
      uf-toolbar-languages
    v-content
      router-view
</template>

<script>
import {auth, db} from '@/store/firebase'
import {mapState} from 'vuex'
import { store } from '@/store'

import { EventBus } from '@/event-bus'
import UfPatientDetail from '@/components/ultra-fetal/home/PatientDetail'
import UfToolbarLanguages from '@/components/ultra-fetal/core/Locales'

export default {
  name: 'Main',

  props: {
    patientId: {
      type: String
    }
  },

  components: {
    UfPatientDetail,
    UfToolbarLanguages
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
      company: (state) => state.company,
      companies: (state) => state.companies,
      isAdmin: state => state.user.role === 'admin',
      studies: state => state.ultraFetal.studies,
      patient: (state) => state.ultraFetal.patient,
      gestation: (state) => state.ultraFetal.gestation,
      gestationInteraction: (state) => state.ultraFetal.gestationInteraction
    }),
    title () {
      return this.$route.name
    },
    companyName () {
      let c = this.companies.find(item => item.identity === this.company)
      return c ? c.name : 'Empresa não encontrada'
    },
    companiesSorted () {
      return this.companies.sort((a, b) => {
        if (a.name.toUpperCase() < b.name.toUpperCase()) {
          return -1
        }
        if (a.name.toUpperCase() > b.name.toUpperCase()) {
          return 1
        }
        return 0
      })
    },
    items () {
      let studiesItems = [
        { title: 'messages.gestationalAge', link: {name: 'Ultra Fetal Form', params: { formId: 'gestationalAge' }} },
        ...this.localItemsAdd
      ]

      const { forms } = this.gestationInteraction
      if (forms) {
        Object.entries(forms).forEach(([key, value]) => {
          const keyStudy = key.split('.')[0]
          const query = studiesItems.find(item => item.title.indexOf(keyStudy) > -1)
          if (query !== undefined) return
          let newItem = null
          if (keyStudy === '1stinitialquarter') newItem = { title: 'messages.1stinitialquarter', link: {name: 'Ultra Fetal Form', params: { formId: '1stinitialquarter' }} }
          if (keyStudy === '1stinitialtracking') newItem = { title: 'messages.1stinitialtracking', link: {name: 'Ultra Fetal Form', params: { formId: '1stinitialtracking' }} }
          if (keyStudy === '2ndand3rdquarter') newItem = { title: 'messages.2ndand3rdquarter', link: {name: 'Ultra Fetal Form', params: { formId: '2ndand3rdquarter' }} }
          if (keyStudy === 'morphological') newItem = { title: 'words.morphological', link: {name: 'Ultra Fetal Form', params: { formId: 'morphological' }} }
          if (keyStudy === 'obstetricdoppler') newItem = { title: 'messages.obstetricdoppler', link: {name: 'Ultra Fetal Form', params: { formId: 'obstetricdoppler' }} }
          if (keyStudy === 'fetalBiophysicalProfile') newItem = { title: 'messages.fetalBiophysicalProfile', link: {name: 'Ultra Fetal Form', params: { formId: 'fetalBiophysicalProfile' }} }
          if (keyStudy === 'cardiotoco') newItem = { title: 'messages.cardiotoco', link: {name: 'Ultra Fetal Form', params: { formId: 'cardiotoco' }} }
          if (keyStudy === 'riskprematurebirth') newItem = { title: 'messages.riskprematurebirth', link: {name: 'Ultra Fetal Form', params: { formId: 'riskprematurebirth' }} }
          if (keyStudy === 'gynecologic') newItem = { title: 'messages.gynecologic', link: {name: 'Ultra Fetal Form', params: { formId: 'gynecologic' }} }
          if (keyStudy === 'examemama') newItem = { title: 'messages.examemama', link: {name: 'Ultra Fetal Form', params: { formId: 'examemama' }} }
          if (keyStudy === 'ecocardiogramafetal') newItem = { title: 'ecocardiogramafetal', link: {name: 'Ultra Fetal Form', params: { formId: 'ecocardiogramafetal' }} }
          if (newItem) studiesItems.push(newItem)
        })
      }

      studiesItems.push({
        title: 'messages.newForm',
        btnIcon: 'add_circle_outline',
        color: 'info',
        itemsAdd: [
          { title: 'messages.1stinitialquarter', link: {name: 'Ultra Fetal Form', params: { formId: '1stinitialquarter' }} },
          { title: 'messages.1stinitialtracking', link: {name: 'Ultra Fetal Form', params: { formId: '1stinitialtracking' }} },
          { title: 'messages.2ndand3rdquarter', link: {name: 'Ultra Fetal Form', params: { formId: '2ndand3rdquarter' }} },
          { title: 'words.morphological', link: {name: 'Ultra Fetal Form', params: { formId: 'morphological' }} },
          { title: 'messages.fetalBiophysicalProfile', link: {name: 'Ultra Fetal Form', params: { formId: 'fetalBiophysicalProfile' }} },
          { title: 'messages.obstetricdoppler', link: {name: 'Ultra Fetal Form', params: { formId: 'obstetricdoppler' }} },
          { title: 'messages.cardiotoco', link: {name: 'Ultra Fetal Form', params: { formId: 'cardiotoco' }} },
          { title: 'ecocardiogramafetal', link: {name: 'Ultra Fetal Form', params: { formId: 'ecocardiogramafetal' }} },
          { title: 'messages.riskprematurebirth', link: {name: 'Ultra Fetal Form', params: { formId: 'riskprematurebirth' }} },
          { title: 'messages.gynecologic', link: {name: 'Ultra Fetal Form', params: { formId: 'gynecologic' }} },
          { title: 'messages.examemama', link: {name: 'Ultra Fetal Form', params: { formId: 'examemama' }} }
        ]
      })
      return [
        {
          title: 'words.gestations',
          link: {
            name: 'Ultra Fetal Gestations'
          },
          expend: false
        },
        {
          title: 'words.medias',
          link: {
            name: 'Ultra Fetal Medias'
          },
          expend: false
        },
        {
          title: 'words.forms',
          expend: true,
          items: studiesItems
        },
        {
          title: 'words.report',
          link: {
            name: 'Ultra Fetal Form Conclusion'
          },
          expend: false
        },
        {
          title: 'words.notes',
          link: {
            name: 'Ultra Fetal Form Observations'
          },
          expend: false
        },
        {
          title: 'words.summary',
          link: {
            name: 'Ultra Fetal Form Summary'
          },
          expend: false
        }
      ]
    }
  },

  watch: {
    gestationInteraction (val) {
      if (val.iuid === undefined || this.gestationInteraction.iuid !== val.iuid) this.localItemsAdd = []
    }
  },

  data () {
    return {
      drawer: true,
      localItemsAdd: [],
      toolbarItems: [
        {
          icon: 'home',
          title: this.$t('words.home'),
          link: '/'
        },
        {
          icon: 'person',
          title: this.$tc('words.patient', 2),
          link: '/patients'
        },
        {
          icon: 'list',
          title: this.$t('words.studies'),
          link: '/studies'
        }
      ]
    }
  },

  mounted () {
    if (this.patientId) {
      this.$store.dispatch('ultraFetal/getPatient', this.patientId)
    }
    EventBus.$on('toogleDrawer', payload => {
      this.drawer = [undefined, null].indexOf(payload) < 0 ? payload : !this.drawer
    })
  },

  beforeDestroy () {
    this.$store.dispatch('ultraFetal/unsubscribe', 'GestationInteraction')
  },

  methods: {
    changeCompany (id) {
      store.dispatch('setCompany', id)
      this.$router.push('/')
    },
    signOut () {
      auth.signOut()
      .then((res) => {
        this.$router.push('/login')
      })
      .catch((err) => {
        console.log(err)
      })
    },
    history () {
      alert('Em breve!')
    },
    async addItem (title, itemAdd) {
      let item = this.localItemsAdd.find(itemSearch => itemSearch.title === title)
      if (item !== undefined) return
      this.examRequiriments(itemAdd.title)
        .then(res => {
          if (!res) return
          this.localItemsAdd.push(itemAdd)
          let { forms } = this.gestationInteraction
          const fieldKey = itemAdd.link.params.formId + '.hasData'
          // Salva direto no banco. (Casos que o médico não está em um Form)
          // setTimeout(() => {
          //   db.doc('gestationInteraction/' + iuid).update({forms})
          // }, 7000)
          forms[fieldKey] = true
          // db.doc('gestationInteraction/' + iuid).update({forms})
          // Salva via Form
          EventBus.$emit('eventField', { event: 'updateResultForm', val: { field: fieldKey, value: true } })
          setTimeout(() => {
            this.$router.push(itemAdd.link)
          }, 2000)
        })
    },
    removeExamForm (formId, formName) {
      const userConfirm = confirm(`${this.$t('messages.confirmRemoveForm')} : ${this.$t(formName)}?`)
      if (!userConfirm) return

      let { iuid, forms } = this.gestationInteraction
      let formsFix = Object.assign({}, forms)
      Object.entries(forms).forEach(([key, value]) => {
        if (key.indexOf(formId) === 0) {
          delete formsFix[key]
        }
      })

      db.doc('gestationInteraction/' + iuid).update({forms: formsFix})

      // TODO: Atualizar o resultForm

      this.localItemsAdd = this.localItemsAdd.filter(item => item.link.params.formId !== formId)

      if (formId === this.$route.params.formId) {
        this.$router.push({name: 'Ultra Fetal Form', params: { formId: 'gestationalAge' }})
      }
    },
    async examRequiriments (title) {
      const gestationalExams = [
        'messages.1stinitialtracking',
        'messages.2ndand3rdquarter',
        'words.morphological',
        'ecocardiogramafetal',
        'messages.obstetricdoppler',
        'messages.cardiotoco',
        'messages.1stinitialquarter'
      ]
      const patientYear = (this.patient.birthdate && this.patient.birthdate.getFullYear()) ? this.patient.birthdate.getFullYear() : null
      const minimumAge = patientYear ? ((new Date().getFullYear() - patientYear) > 10) : true

      if (!minimumAge && gestationalExams.includes(title)) {
        const result = await this.$swal.fire({
          type: 'warning',
          title: 'Idade da paciente inferior a idade mínima!',
          text: 'Deseja criar o exame mesmo assim?',
          showCancelButton: true,
          focusConfirm: true,
          confirmButtonText: 'SIM',
          cancelButtonText: 'NÃO'
        })

        if (!result.value) {
          this.$router.push({ name: 'Ultra Fetal Form', params: { formId: 'gestationalAge' } })
          return false
        }
      }

      if (!this.gestationInteraction.forms['gestationalAge.info.fetos'] && !this.gestationInteraction.forms['gestationalAge.info.qtdSacoGestacional'] && title === 'messages.1stinitialquarter') {
        const result = await this.$swal.fire({
          type: 'warning',
          title: 'Campos Sacos Gestacionais e Embriões/Fetos vazios!',
          text: 'Deseja criar o exame mesmo assim?',
          showCancelButton: true,
          focusConfirm: true,
          confirmButtonText: 'SIM',
          cancelButtonText: 'NÃO'
        })

        if (!result.value) {
          this.$router.push({ name: 'Ultra Fetal Form', params: { formId: 'gestationalAge' } })
          return false
        } else return true
      }

      if ((!this.gestationInteraction.forms['gestationalAge.info.qtdSacoGestacional']) && title === 'messages.1stinitialquarter') {
        const result = await this.$swal.fire({
          type: 'warning',
          title: 'Campo Sacos Gestacionais vazio!',
          text: 'Deseja criar o exame mesmo assim?',
          showCancelButton: true,
          focusConfirm: true,
          confirmButtonText: 'SIM',
          cancelButtonText: 'NÃO'
        })

        if (!result.value) {
          this.$router.push({ name: 'Ultra Fetal Form', params: { formId: 'gestationalAge' } })
          return false
        } return true
      }

      if ((!this.gestationInteraction.forms['gestationalAge.info.fetos']) && gestationalExams.includes(title)) {
        const result = await this.$swal.fire({
          type: 'warning',
          title: 'Campo Embriões/Fetos vazio!',
          text: 'Deseja criar o exame mesmo assim?',
          showCancelButton: true,
          focusConfirm: true,
          confirmButtonText: 'SIM',
          cancelButtonText: 'NÃO'
        })

        if (!result.value) {
          this.$router.push({ name: 'Ultra Fetal Form', params: { formId: 'gestationalAge' } })
          return false
        }
      }
      return true
    }
  }
}
</script>

<style scoped>
  .page-container {
      max-width: 1185px !important;
      padding-top: 75px;
      padding-bottom: 0;
      transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      flex: 1 1 100%;
      margin: auto;
      padding: 24px;
      width: 100%;
  }
  @media only screen and (min-width: 1264px) {
    .page-container {
        max-width: 1185px;
    }
  }
  @media only screen and (min-width: 960px) {
    .page-container {
        max-width: 900px;
    }
  }
  .select-lang {
    max-width: 40px;
    padding-top: 16px
  }
</style>



// WEBPACK FOOTER //
// src/pages/ultra-fetal/Main.vue